import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../constants/defaults';
import { changeMapLoaded, changeMapZoom } from '../actions';
import _ from 'lodash';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import * as turf from '@turf/turf'

const Fragment = React.Fragment;

const MapDiv = styled.div`
  width: 100%;
  height: 100%;
  border-bottom:1px solid #eee;
`;


class CityMapContainer extends Component {
  constructor(props){
    super(props);

  }
  componentDidMount() {
    window.mapboxgl.accessToken = "pk.eyJ1IjoiZGF0YXBsdXNmZW1pbmlzbSIsImEiOiJjazl6aHc4cjQwNnRwM2xwZHJxZ2F4dm9vIn0.T9pZe5G7wOLEFLwdDlGBdg";//process.env.MAPBOX_TOKEN;

    this.map = new window.mapboxgl.Map({
      container: this.refsMapContainer,
      style: 'mapbox://styles/dataplusfeminism/ckd56g7q00bkm1imrngrva4uh',
      zoom: 3,
      minZoom: 3,
      maxZoom: 15,
      center: [ -90, 40],
      // interactive: false
    });


    window.map = this.map;
    this.map.on('style.load', this.handleStyleLoad.bind(this));
  
  }

  async handleStyleLoad() {
    let { geojson } = this.props;

    this.map.addSource('county_places', {
      "type": 'vector',
      "tiles": [`${API_URL}/tiles/county_subdivisions/${geojson.properties.gid}/places/{z}/{x}/{y}.pbf`],
      "minZoom": 3,
      "maxZoom": 22
    });

    this.map.addLayer({
      'id': 'county_places_layer',
      'source': 'county_places',
      'source-layer': 'public.place_names',
      'type': 'circle',
      "minzoom": 3,
      'paint': {
        'circle-opacity':0.5,
        'circle-color': "#999",
        'circle-radius': 3
      }
    });


    this.map.addSource('county_osm_roads', {
      "type": 'vector',
      "tiles": [`${API_URL}/tiles/county_subdivisions/${geojson.properties.gid}/osm_roads/{z}/{x}/{y}.pbf`],
      "minZoom": 3,
      "maxZoom": 22
    });

    this.map.addLayer({
      'id': 'osm_roads_layer',
      'source': 'county_osm_roads',
      'source-layer': 'public.osm_roads',
      'type': 'line',
      "minzoom": 3,
      'paint': {
        'line-opacity':[
          'match',
          ['get', 'dominant_race'],
          'black',
          0.5,
          'hispanic',
          0.5,
          'asian',
          0.5,
          'white',
          0.5,
          0.5
        ],
        'line-color': [
          'match',
          ['get', 'dominant_race'],
          'black',
          '#1161D9',
          'hispanic',
          '#D98911',
          'asian',
          '#D5D911',
          'white',
          '#08A751',
          /* other */ '#EEEEEE'
          ]        
      }
    }, "admin-0-boundary-disputed");

    
    var bbox = turf.bbox(geojson);
    
    this.map.addSource('bounds', {
      type: 'geojson',
      data: geojson
    });

    this.map.addLayer({
      'id': 'bounds-layer',
      'type': 'line',
      'source': 'bounds',
      'layout': {},
      'paint': {
        'line-color': '#000000',
        'line-opacity': 0.3
      }
    });

    this.map.fitBounds([
      [bbox[0], bbox[1]],
      [bbox[2], bbox[3]]
    ], {
      padding: {top: 20, bottom:20, left: 20, right: 20},
      duration: 0
    })
  }

  render() {
    return (
      <MapDiv ref={c => { this.refsMapContainer = c; }}>
      </MapDiv>
    );
  }
}

let mapStateToProps = state => {

  return {
    windowWidth: state.windowWidth,
    windowHeight: state.windowHeight
  }
}

export default withRouter(connect(mapStateToProps)(CityMapContainer));